import React from "react";
import { Box, Typography } from "@mui/material";

type PickleballServerIndicatorProps = {
  serverNumber: number; // 1 or 2
};

/**
 * Pickleball server number indicator - displays a gold ball with the server number inside
 * This represents the "third number" in pickleball scoring (e.g., "4-2-2")
 * Only shown for pickleball doubles matches
 */
const PickleballServerIndicator: React.FC<PickleballServerIndicatorProps> = ({
  serverNumber,
}) => {
  // Only show if serverNumber is 1 or 2
  if (serverNumber !== 1 && serverNumber !== 2) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 18,
        height: 18,
        borderRadius: "50%",
        backgroundColor: "#FFD700", // Gold color
        border: "1px solid #DAA520", // Darker gold border
        marginLeft: "4px",
        marginRight: "2px",
      }}
    >
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: "bold",
          color: "#000",
          lineHeight: 1,
        }}
      >
        {serverNumber}
      </Typography>
    </Box>
  );
};

export default PickleballServerIndicator;
